module.exports = __webpack_public_path__ + "media/images/btn_s-0513c36416c154be709d672382762441.gif";